




import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import CodeEditor from '@/components/CodeEditor.vue';
import {requestNotificationPermission} from '@/services/notification-service';

@Component({
    components: {
        CodeEditor,

    },
})
export default class Challenge extends Vue {

    protected created() {
        requestNotificationPermission();
    }

}
